import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-C4OEIS7N.mjs";
import "./chunk-7PKI6E2E.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
